import React, { useState } from "react"
import PropTypes from "prop-types"
import Vimeo from "@u-wave/react-vimeo"

export const VimeoPlayer = ({ children, id }) => {
  const [paused, setPause] = useState(true)

  return (
    <div className="absolute inset-0 overflow-hidden bg-black">
      {paused && (
        <>
          {children}
          <div className="absolute inset-0 flex justify-center items-center z-20">
            <button
              onClick={() => setPause(false)}
              className="justify-center items-center w-20 h-20 lg:w-25 lg:h-25 opacity-80 hover:opacity-100"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
                <circle cx="51" cy="51" r="49" stroke="white" strokeWidth="4" />
                <path d="M74 51L39.5 70.9186L39.5 31.0814L74 51Z" fill="white" />
              </svg>
              <span className="sr-only">Play Video</span>
            </button>
          </div>
        </>
      )}
      <div className={paused && "hidden"}>
        <Vimeo video={id} controls={true} showTitle={false} responsive paused={paused} />
      </div>
    </div>
  )
}
const Poster = ({ children }) => {
  return <div className="absolute inset-0 z-10">{children}</div>
}

VimeoPlayer.Poster = Poster

VimeoPlayer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
}

Poster.propTypes = {
  children: PropTypes.node,
}
